import styled from 'styled-components/macro';
import { Icon } from '~/components';

export const DataListItem = styled.div`
  padding: 15px;
  background-color: ${({ primaryColor }) => primaryColor || '#a9aeb417'};
  display: flex;
  flex-direction: column;
  min-height: 130px;
  opacity: ${({ transparent }) => (transparent ? 0 : 1)};
`;
export const DataListItemLabel = styled.div`
  color: ${({ theme, textColor }) => textColor || theme.gray2};
  text-transform: capitalize;
`;
export const DataListItemValue = styled.div`
  color: ${({ theme, competition }) =>
    competition === 1 ? theme.coral : theme.turquoise};
  font-size: 30px;
  font-weight: 500;
  text-align: right;
`;
export const DataListItemBottom = styled.div`
  display: flex;
  align-items: end;
`;
export const DataListItemIsTop = styled.div`
  font-size: 9px;
  color: ${({ theme }) => theme.white};
  display: flex;
  align-items: center;
`;
export const DataListItemIsTopIcon = styled(Icon)`
  margin-right: 5px;
`;

export const Grow = styled.div`
  flex-grow: 1;
`;
